import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideExperimentalZonelessChangeDetection,
} from '@angular/core'
import { provideRouter } from '@angular/router'
import { routes } from './app.routes'
import { NgxIndexedDBModule } from 'ngx-indexed-db'
import { dbConfig } from '../environments/dbConfig'
import { WindowRef } from './providers/WindowRef'
import { SdkService } from './services/sdk.service'
import { TranslationService } from './services/translation.service'
import { AssetsService } from './services/assets.service'
import { provideHttpClient } from '@angular/common/http'
import { ConfigService } from './services/config.service'
import { SubscriptionCatalogService } from './services/subscription-catalog.service'
import { VhrCmsService } from './services/vhr-cms.service'
import { GtmService } from './services/gtm.service'


export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideHttpClient(),
    provideRouter(routes),
    importProvidersFrom(NgxIndexedDBModule.forRoot(dbConfig)),
    WindowRef,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeConfig,
      deps: [
        ConfigService,
        TranslationService,
        AssetsService,
        SubscriptionCatalogService,
        VhrCmsService
      ],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSdkFactory,
      deps: [SdkService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGtm,
      deps: [GtmService],
      multi: true
    }
  ],
}

export function initializeSdkFactory(
  sdkService: SdkService
): () => Promise<boolean> {
  return () => sdkService.initializeSDK()
}


export function initializeSubscriptionCatalog(
  subscriptionCatalogService: SubscriptionCatalogService
): () => Promise<boolean> {
  return () => subscriptionCatalogService.initializeSubscriptionCatalog()
}

export function initializeVhrCmsService(
  vhrCmsService: VhrCmsService
): () => Promise<boolean> {
  return () => vhrCmsService.initializeVhrCmsService()
}

export function initializeConfig(
  configService: ConfigService,
  translationService: TranslationService,
  assetsService: AssetsService,
  catalogService: SubscriptionCatalogService,
  vhrCmsService: VhrCmsService
): () => Promise<boolean> {
  const callStack = [
    () => configService.initializeConfig(),
    () => translationService.initializeTranslations(),
    () => assetsService.initializeAssets(),
    () => catalogService.initializeSubscriptionCatalog(),
    () => vhrCmsService.initializeVhrCmsService()
  ]

  return () => {
    return callStack.reduce((promiseChain, currentService) => {
      return promiseChain.then((accumulator) =>
        currentService().then((result) => accumulator && result)
      )
    }, Promise.resolve(true))
  }
}

export function initializeGtm(gtmService: GtmService) {
  return () => {
    gtmService.initGtm('GTM-KQWLRRKD');
  };
}
